import { Config } from "@config";
import { ResponsiveHelper } from "@utils/responsive-helper";
import classNames from "classnames";
import type React from "react";
import { useEffect, useMemo, useState } from "react";
import { DesktopMenu } from "./DesktopMenu";
import { MobileMenu } from "./MobileMenu";
import type { Variant } from "./type";

interface Props {
	variant?: Variant;
}

/**
 * @Shortcode
 *
 * @title "Főmenü"
 * @shortcode "main_menu"
 * @type "widget"
 * @propsList "[{"variant":"retail"},{"variant":"corporate"}]"
 * @lazyHydrate "whenIdle"
 * @importMode "eager"
 */
const MainMenu: React.FC<Props> = ({ variant = "retail" }) => {
	const [isMobile, setIsMobile] = useState(false);
	const [openMobileMenu, setOpenMobileMenu] = useState(false);

	const responsiveHelper = useMemo(() => new ResponsiveHelper("lg", (isOver) => setIsMobile(!isOver)), []);

	useEffect(() => {
		if (!Config.isSsr()) {
			setIsMobile(!responsiveHelper.getActualStatus());
			responsiveHelper.startObserving();
		}

		const button = document.querySelector(".mobile-menu");
		const toggle = (e: Event) => {
			const target = e.target as HTMLElement;
			target.classList.toggle("closed");
			setOpenMobileMenu((prev) => !prev);
		};

		button?.addEventListener("click", toggle);
		return () => {
			responsiveHelper.stopObserving();
			button?.removeEventListener("click", toggle);
		};
	}, [responsiveHelper]);

	const label = variant === "retail" ? "Lakossági főmenü" : "Vállalati főmenü";

	return (
		<nav id="mainMenu" className={classNames("main-menu", `theme-${variant}`)} aria-label={label}>
			{isMobile ? openMobileMenu && <MobileMenu variant={variant} /> : <DesktopMenu variant={variant} />}
		</nav>
	);
};

export default MainMenu;
